module.exports = __webpack_public_path__ + "img/coinbankB32.912eadfb.jpg";